export const onlineGridModalProps = {
  title: 'Product Submission Grid',
  destroyOnClose: true,
  width: 'min(1440px, 94vw)',
  style: { top: 24 },
  bodyStyle: {
    maxHeight: 'calc(100vh - 160px)',
    overflowY: 'auto',
  },
  maskClosable: false,
};
